import React from "react";
import { Checkbox } from "@americanexpress/dls-react";
import { useTranslation } from "react-i18next";
import { useUniqueId } from "../../../hooks/useUniqueId";
import { PA_PERMISSION_ONLINE } from "../../Common/constants";

const PAPermissionOnline = ({ formik }) => {
  const { t } = useTranslation("common");
  const baseId = useUniqueId("pa");

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    formik.setFieldValue("paPermissionOnline", (checked && PA_PERMISSION_ONLINE.has(name)));
  };

  return (
    <section id="pa-permission-online-info">
      <div className="row">
        <div className="col-xs-12">
          <h4 className="heading-4 dls-deep-blue pad-2-t pad-2-b">
            {t("newuser.paPermissionOnlineHeader")}
          </h4>
        </div>
      </div>
      <p>
        {t("newuser.paPermissionOnlineDesc")}
      </p>
      <Checkbox
        id={`${baseId}-paPermissionOnline`}
        name="paPermissionOnline"
        label={t("newuser.paPermissionOnlineCheckbox")}
        checked={formik.values.paPermissionOnline}
        onChange={handleCheckboxChange}
      />
    </section>
  );
};

export default PAPermissionOnline;
